import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../Layout";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import useApi from "Hooks/useApi";
import { saveAs } from "file-saver";
import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  anchor: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(1),
    textDecoration: "underline",
  },
}));

export default function MonthlyReport(props) {
  const { request, convertQueryParam } = useApi();
  const classes = useStyles();

  const [statuseFromDate, setStatusetFromDate] = React.useState(null);
  const [statuseToDate, setStatuseToDate] = React.useState(null);
  const [isStatuseDisable, setIsStatuseDisable] = React.useState(false);

  const [reportFromDate, setReportFromDate] = React.useState(null);
  const [reportToDate, setReportToDate] = React.useState(null);
  const [isReportDisable, setIsReportDisable] = React.useState(false);

  const [accountFromDate, setAccountFromDate] = React.useState(null);
  const [accountToDate, setAccountToDate] = React.useState(null);
  const [isAccountDisable, setIsAccountDisable] = React.useState(false);

  const [userFromDate, setUserFromDate] = React.useState(null);
  const [userToDate, setUserToDate] = React.useState(null);
  const [isUserDisable, setIsUserDisable] = React.useState(false);

  const messages = message();
  const maxDate = dayjs();
  const oldMaxDateLimit = dayjs('2026-04-01T00:00:00');
  const oldMaxDate = oldMaxDateLimit.isBefore(maxDate, 'month') ? oldMaxDateLimit : maxDate;

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - CSVダウンロード";

    setStatusetFromDate(dayjs(oldMaxDate).subtract(1, "month").format("YYYY-MM"));
    setStatuseToDate(dayjs(oldMaxDate).subtract(1, "month").format("YYYY-MM"));

    setReportFromDate(dayjs(oldMaxDate).subtract(1, "month").format("YYYY-MM"));
    setReportToDate(dayjs(oldMaxDate).subtract(1, "month").format("YYYY-MM"));

    setAccountFromDate(dayjs(oldMaxDate).subtract(1, "month").format("YYYY-MM"));
    setAccountToDate(dayjs(oldMaxDate).subtract(1, "month").format("YYYY-MM"));

    setUserFromDate(dayjs(maxDate).subtract(1, "month").format("YYYY-MM"));
    setUserToDate(dayjs(maxDate).subtract(1, "month").format("YYYY-MM"));
  }, []);

  const handleRange = (target) => {
    console.log(target);
    switch (target) {
      case "statuse":
        fetchStatuseCsv({
          range: [
            dayjs(statuseFromDate).format("YYYY-MM"),
            dayjs(statuseToDate).format("YYYY-MM"),
          ],
        });
        break;
      case "report":
        fetchReportCsv({
          range: [
            dayjs(reportFromDate).format("YYYY-MM"),
            dayjs(reportToDate).format("YYYY-MM"),
          ],
        });
        break;
      case "account":
        fetchAccountCsv({
          range: [
            dayjs(accountFromDate).format("YYYY-MM"),
            dayjs(accountToDate).format("YYYY-MM"),
          ],
        });
        break;
      case "user":
        fetchUserCsv({
          range: [
            dayjs(userFromDate).format("YYYY-MM"),
            dayjs(userToDate).format("YYYY-MM"),
          ],
        });
        break;
    }
  };

  // 月次利用CSVデータ取得
  const fetchStatuseCsv = (params) => {
    request({
      method: "GET",
      url: `admin/download/statuses?${convertQueryParam({
        range: params.range,
      })}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        saveAs(blob,
          `月次利用データ-${(params.range[0]).replace(/-/g, "")}-` +
          `${(params.range[1]).replace(/-/g, "")}.csv`
        );
      } else {
        alert(messages.errorMsg.blobSizeZero);
      }
    });
  };

  // 月次報告用CSVデータ取得
  const fetchReportCsv = (params) => {
    request({
      method: "GET",
      url: `admin/download/reports?${convertQueryParam({
        range: params.range,
      })}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        saveAs(blob,
          `月次報告-${(params.range[0]).replace(/-/g, "")}-` +
          `${(params.range[1]).replace(/-/g, "")}.csv`
        );
      } else {
        alert(messages.errorMsg.blobSizeZero);
      }
    });
  };

  // CSM用CSVデータ取得
  const fetchAccountCsv = (params) => {
    request({
      method: "GET",
      url: `admin/download/accounts?${convertQueryParam({
        range: params.range,
      })}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        saveAs(blob,
          `CMS-${(params.range[0]).replace(/-/g, "")}-` +
          `${(params.range[1]).replace(/-/g, "")}.csv`
        );
      } else {
        alert(messages.errorMsg.blobSizeZero);
      }
    });
  };

  // ユーザリストCSVデータ取得
  const fetchUserCsv = (params) => {
    request({
      method: "GET",
      url: `admin/download/users?${convertQueryParam({
        range: params.range,
      })}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        saveAs(blob,
          `ユーザリスト-${(params.range[0]).replace(/-/g, "")}-` +
          `${(params.range[1]).replace(/-/g, "")}.csv`
        );
      } else {
        alert(messages.errorMsg.blobSizeZero);
      }
    });
  };

  const statuseDateValidation = (date, type) => {
    if (!statuseFromDate && !statuseToDate) return;
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM").isValid()) {
      if (type == "from") {
        const toMonth = dayjs(statuseToDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 終了日付が開始日付より後の日かチェック
        if ((dayjs(toMonth).isSameOrAfter(dayjs(selectedMonth)))){
          setStatusetFromDate(dayjs(date));
          setIsStatuseDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "to"){
        const fromMonth = dayjs(statuseFromDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 開始日付が終了日付より前の日かチェック
        if ((dayjs(fromMonth).isSameOrBefore(dayjs(selectedMonth)))) {
          setStatuseToDate(dayjs(date));
          setIsStatuseDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      }
      return;
    }
    setIsStatuseDisable(true);
    return;
  }

  const reportDateValidation = (date, type) => {
    if (!reportFromDate && !reportToDate) return;
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM").isValid()) {
      if (type == "from") {
        const toMonth = dayjs(reportToDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 終了日付が開始日付より後の日かチェック
        if ((dayjs(toMonth).isSameOrAfter(dayjs(selectedMonth)))){
          setReportFromDate(dayjs(date));
          setIsReportDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "to"){
        const fromMonth = dayjs(reportFromDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 開始日付が終了日付より前の日かチェック
        if ((dayjs(fromMonth).isSameOrBefore(dayjs(selectedMonth)))) {
          setReportToDate(dayjs(date));
          setIsReportDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      }
      return;
    }
    setIsReportDisable(true);
    return;
  }

  const accountDateValidation = (date, type) => {
    if (!accountFromDate && !accountToDate) return;
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM").isValid()) {
      if (type == "from") {
        const toMonth = dayjs(accountToDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 終了日付が開始日付より後の日かチェック
        if ((dayjs(toMonth).isSameOrAfter(dayjs(selectedMonth)))){
          setAccountFromDate(dayjs(date));
          setIsAccountDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "to"){
        const fromMonth = dayjs(accountFromDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 開始日付が終了日付より前の日かチェック
        if ((dayjs(fromMonth).isSameOrBefore(dayjs(selectedMonth)))) {
          setAccountToDate(dayjs(date));
          setIsAccountDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      }
      return;
    }
    setIsAccountDisable(true);
    return;
  }

  const userDateValidation = (date, type) => {
    if (!userFromDate && !userToDate) return;
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM").isValid()) {
      if (type == "from") {
        const toMonth = dayjs(userToDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 終了日付が開始日付より後の日かチェック
        if ((dayjs(toMonth).isSameOrAfter(dayjs(selectedMonth)))){
          setUserFromDate(dayjs(date));
          setIsUserDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "to"){
        const fromMonth = dayjs(userFromDate).format("YYYY-MM")
        const selectedMonth = dayjs(date).format("YYYY-MM")
        // 開始日付が終了日付より前の日かチェック
        if ((dayjs(fromMonth).isSameOrBefore(dayjs(selectedMonth)))) {
          setUserToDate(dayjs(date));
          setIsUserDisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      }
      return;
    }
    setIsUserDisable(true);
    return;
  }

  const dateError = (error, value, target) => {
    if (error) {
      switch (target) {
        case "statuse":
          setIsStatuseDisable(true);
          break;
        case "report":
          setIsReportDisable(true);
          break;
        case "account":
          setIsAccountDisable(true);
          break;
        case "user":
          setIsUserDisable(true);
          break;
      }
    }
    return;
  }

  return (
    <Layout
      content={
        <Grid>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" color="primary">
              月次利用データ生成
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="期間を指定"
                  secondary={
                    <React.Fragment>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={statuseFromDate}
                            maxDate={maxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "statuse")}
                            onChange={(date) => statuseDateValidation(date, "from")}
                          />
                          <div className={classes.divider}>〜</div>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={statuseToDate}
                            maxDate={maxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "statuse")}
                            onChange={(date) => statuseDateValidation(date, "to")}
                          />
                          <div>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              disabled={isStatuseDisable}
                              onClick={() => handleRange("statuse")}
                            >
                              CSVダウンロード
                            </Button>
                          </div>
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Paper>

          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" color="primary">
              月次報告用データ生成
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="旧フォーマット：期間を指定（2026年3月まで）"
                  secondary={
                    <React.Fragment>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={reportFromDate}
                            maxDate={oldMaxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "report")}
                            onChange={(date) => reportDateValidation(date, "from")}
                          />
                          <div className={classes.divider}>〜</div>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={reportToDate}
                            maxDate={oldMaxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "report")}
                            onChange={(date) => reportDateValidation(date, "to")}
                          />
                          <div>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              disabled={isReportDisable}
                              onClick={() => handleRange("report")}
                            >
                              CSVダウンロード
                            </Button>
                          </div>
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Paper>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" color="primary">
              CMS向けデータ生成
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="旧フォーマット：期間を指定（2026年3月まで）"
                  secondary={
                    <React.Fragment>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={accountFromDate}
                            maxDate={oldMaxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "account")}
                            onChange={(date) => accountDateValidation(date, "from")}
                          />
                          <div className={classes.divider}>〜</div>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={accountToDate}
                            maxDate={oldMaxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "account")}
                            onChange={(date) => accountDateValidation(date, "to")}
                          />
                          <div>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              disabled={isAccountDisable}
                              onClick={() => handleRange("account")}
                            >
                              CSVダウンロード
                            </Button>
                          </div>
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Paper>

          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" color="primary">
              ユーザリスト出力
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="期間を指定"
                  secondary={
                    <React.Fragment>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={userFromDate}
                            maxDate={maxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "user")}
                            onChange={(date) => userDateValidation(date, "from")}
                          />
                          <div className={classes.divider}>〜</div>
                          <DatePicker
                            format="yyyy/MM"
                            margin="normal"
                            views={["year", "month"]}
                            value={userToDate}
                            maxDate={maxDate}
                            maxDateMessage={
                              (messages.validation.maxDate).replace(
                                "$1",
                                maxDate.format("YYYY-MM")
                              )
                            }
                            onError={(error, value) => dateError(error, value, "user")}
                            onChange={(date) => userDateValidation(date, "to")}
                          />
                          <div>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              disabled={isUserDisable}
                              onClick={() => handleRange("user")}
                            >
                              CSVダウンロード
                            </Button>
                          </div>
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      }
    />
  );
}
